// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { PlanCreditOperationsService } from '../generated/api/planCreditOperations.service';

@Injectable({ providedIn: 'root' })
export class PlanCreditOperationsClientService {
  constructor(private readonly client: PlanCreditOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    creditTransactionId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanCreditRecoveryResponse> {
    if (!this.client)
      throw new Error('PlanCreditOperationsService is not available');
    return this.client.planCreditOperationsGet(
      creditTransactionId,
      'body',
      reportProgress,
      options,
    );
  }

  getRetries(
    creditTransactionId: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanCreditRetryPage> {
    if (!this.client)
      throw new Error('PlanCreditOperationsService is not available');
    return this.client.planCreditOperationsGetRetries(
      creditTransactionId,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  retry(
    creditTransactionId: string,
    request: WrapperApi.PlanCreditRetryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PlanCreditRetryResponse> {
    if (!this.client)
      throw new Error('PlanCreditOperationsService is not available');
    return this.client.planCreditOperationsRetry(
      creditTransactionId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
